/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */
import { createReducer } from 'reduxsauce';
import { StkTrfIndexTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const stkTrfIndexResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  selectedDocuments: []
});

export const stkTrfIndexFetchStkTrfIndexLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const stkTrfIndexFetchStkTrfIndexSuccess = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const stkTrfIndexAddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const stkTrfIndexRemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const stkTrfIndexSetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [StkTrfIndexTypes.STK_TRF_INDEX_RESET_TIMESTAMP]: stkTrfIndexResetTimestamp,
  [StkTrfIndexTypes.STK_TRF_INDEX_FETCH_STK_TRF_INDEX_LOADING]: stkTrfIndexFetchStkTrfIndexLoading,
  [StkTrfIndexTypes.STK_TRF_INDEX_FETCH_STK_TRF_INDEX_SUCCESS]: stkTrfIndexFetchStkTrfIndexSuccess,
  [StkTrfIndexTypes.STK_TRF_INDEX_ADD_SELECTED_DOCUMENTS]: stkTrfIndexAddSelectedDocuments,
  [StkTrfIndexTypes.STK_TRF_INDEX_REMOVE_SELECTED_DOCUMENTS]: stkTrfIndexRemoveSelectedDocuments,
  [StkTrfIndexTypes.STK_TRF_INDEX_SET_WORKSPACE_VISIBLE]: stkTrfIndexSetWorkspaceVisible
});
